<template>
		<div class="checkbox" :class="{correct: isClassCorrective}">
			<label><input :disabled="quizScores[currentQuestion].answer !== ''" type="checkbox" name="question" :value="quizValue" v-model="quizScores[currentQuestion].model">{{quizValue}}</label>
		</div>
</template>

<script>
export default {
  props: {
    currentQuestion: Number,
    quizScores: Array,
    quizValue: String,
  },
  data() {
    return {

    };
  },
  computed: {
    isClassCorrective() {
      for (let i = 0; i < this.quizScores[this.currentQuestion].corrective.length; i++) {
        if (this.quizValue == this.quizScores[this.currentQuestion].corrective[i] && this.quizScores[this.currentQuestion].answer != '') {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
	@import '../../styles/colors';

	/*w/ radio btn*/
	.checkbox {
		border: 1px solid #000;
		padding: 0.6em;
		margin: .5rem 0px;
		width: 100%;

		label {
				display: flex;
				align-items: center;
				margin-bottom: 0;
		}
		input[type=checkbox] {
				/* one way to help with spacing */
				margin-right: 12px;
				min-width: 16px !important;
		}
	}

	.disabled {
			pointer-events: none;

				/* for "disabled" effect */
				opacity: 0.5;
				background: #CCC;
	}


    .btn-default {
            border-radius: 0px;
            padding: 15px 10px;
    }

    .correct {
        background-color: $feedback-green;
        color: #000;
        font-weight: 700;
    }

    .incorrect {
    background-color: #77b84a !important;
    }

</style>
